import React from 'react'
import ReactDOM from 'react-dom/client'
import { MsalProvider } from '@azure/msal-react'
import App from './App.tsx'
import { msalInstance, initializeMsal } from './config/msalConfig'
import { CurrentUserProvider } from './contexts/CurrentUserContext'
import './index.css'

// Initialize MSAL before rendering
initializeMsal().then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <CurrentUserProvider>
          <App />
        </CurrentUserProvider>
      </MsalProvider>
    </React.StrictMode>,
  )
}).catch((error) => {
  console.error('Failed to initialize MSAL:', error)
})
